import React from "react";
import bannerCorredor from "../../../img/banner-corredor.png";

const BannerPlan = () => {
    return (
        <div className="w-full bg-[#029DE0] bg-opacity-10 rounded-b-3xl ">
            <div className="grid items-center grid-cols-1 gap-4 md:pt-16 pt-24 md:grid-cols-[50%,50%] 3xl:w-2/3 2xl:w-3/4 lg:w-4/5 w-5/6 mx-auto">
                <div className="">
                    <div className="w-full md:w-11/12">
                        <div className="flex items-center justify-center gap-1 ">
                            <div
                                className="font-bold text-center text-[#029DE0] 2xl:text-5xl lg:text-4xl md877:text-3xl text-2xl md:text-left  "
                                style={{ lineHeight: "1.3" }}
                            >
                                <p
                                    className="mr-1 inline font-bold text-center  text-[#071829] bg-[#C3EA43] rounded-lg px-2   md:text-left"
                                    style={{
                                        boxDecorationBreak: "clone",
                                        WebkitBoxDecorationBreak: "clone",
                                    }}
                                >
                                    Impulsa tu inmobiliaria
                                </p>
                                <p className="mx-1 inline font-bold text-center  text-[#071829]   md:text-left">
                                    y aumenta tus ventas con nuestra herramienta
                                </p>
                            </div>
                        </div>

                        <p className="md:w-5/6 w-full mx-auto mt-4 text-sm text-center 2xl:text-xl xl:text-lg md877:text-base md:text-left md:mx-0">
                            Gestiona propiedades, optimiza reservas y cierra más
                            negocios con total facilidad.
                        </p>

                        <div
                            onClick={() => {
                                window.open(
                                    "https://calendar.app.google/7aKBqkaqESiPuTtE8"
                                );
                            }}
                            className="w-fit xl:text-base text-sm  md:mx-0 mx-auto  flex justify-center items-center gap-2 rounded-lg text-[#071829] px-4 py-2 bg-gradient-to-r from-[#C3EA43] to-[#E3FF89] mt-5 hover:scale-105 cursor-pointer "
                        >
                            Agenda tu demo
                            <svg
                                className="text-[#071829]"
                                width="12"
                                height="13"
                                viewBox="0 0 16 17"
                                fill="071829"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.375 16.125C5.05859 16.125 4.77734 16.0195 4.56641 15.8086C4.10938 15.3867 4.10938 14.6484 4.56641 14.2266L10.5078 8.25L4.56641 2.30859C4.10938 1.88672 4.10938 1.14844 4.56641 0.726562C4.98828 0.269531 5.72656 0.269531 6.14844 0.726562L12.8984 7.47656C13.3555 7.89844 13.3555 8.63672 12.8984 9.05859L6.14844 15.8086C5.9375 16.0195 5.65625 16.125 5.375 16.125Z"
                                    fill="071829"
                                />
                            </svg>{" "}
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-center w-full  ">
                    <img
                        src={bannerCorredor}
                        alt="banner"
                        className="2xl:h-[500px] xl:h-[450px] lg:h-[400px] md:h-[350px] h-[300px] "
                    />
                </div>
            </div>
        </div>
    );
};

export default BannerPlan;
